var React = require('react');

function Hex (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #ab284e;\n      }\n    ")),React.createElement("path",{"id":"Path_101","data-name":"Path 101","className":"cls-1","d":"M18.168,14.58a2.059,2.059,0,0,1-.893,1.7l-7.03,4.829a2.059,2.059,0,0,1-2.333,0L.892,16.277A2.059,2.059,0,0,1,0,14.581V6.764a2.059,2.059,0,0,1,.912-1.71L7.924.349a2.059,2.059,0,0,1,2.305.007l7.038,4.786a2.059,2.059,0,0,1,.9,1.7Z","transform":"translate(18.168 21.468) rotate(180)","key":1})]);
}

Hex.defaultProps = {"width":"18.168","height":"21.468","viewBox":"0 0 18.168 21.468"};

module.exports = Hex;

Hex.default = Hex;
